import * as i18nInterface from 'src/app/shared/_config/i18n/i18n-interface';
import { FilterGroupEnum } from './filter-group.enum';
import { FilterEnum } from './filter.enum';
import { FilterGroupI } from './filter-group.interface';
import { SpxInputTypeEnum } from '@softpak/components/spx-inputs';

export const filterConstants: FilterGroupI[] = [
    {
        groupTextKey: i18nInterface.textHeathingType,
        key: FilterGroupEnum.rfrOrdHeatingType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: FilterEnum.rfrOrdHeatingTypeSteam,
                filterTextKey: i18nInterface.textSteam,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdHeatingTypeSteam,
            },
            {
                filterKey: FilterEnum.rfrOrdHeatingTypeElectricity,
                filterTextKey: i18nInterface.textElectricity,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdHeatingTypeElectricity,
            },
            {
                filterKey: FilterEnum.rfrOrdHeatingTypeWater,
                filterTextKey: i18nInterface.textWater,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdHeatingTypeWater,
            },
        ],
        isActive: false,
        defaultValue: undefined,
    },
    {
        groupTextKey: i18nInterface.textOrder,
        key: FilterGroupEnum.rfrOrdType,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: FilterEnum.rfrOrdTypeConnect,
                filterTextKey: i18nInterface.textConnect,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdTypeConnect,
            },
            {
                filterKey: FilterEnum.rfrOrdTypeDisconnect,
                filterTextKey: i18nInterface.textDisconnect,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdTypeDisconnect,
            },
        ],
        isActive: false,
        defaultValue: undefined,
    },
    {
        groupTextKey: i18nInterface.textOnReeferLocation,
        key: FilterGroupEnum.rfrOrdOnLocation,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: FilterEnum.rfrOrdOnReeferLocationYes,
                filterTextKey: i18nInterface.textYes,
                filterTextVariables: {
                },
                defaultValue: true,
                targetValue: FilterEnum.rfrOrdOnReeferLocationYes,
            },
            {
                filterKey: FilterEnum.rfrOrdOnReeferLocationNo,
                filterTextKey: i18nInterface.textNo,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdOnReeferLocationNo,
            },
        ],
        isActive: true,
        defaultValue: FilterEnum.rfrOrdOnReeferLocationYes,
        readonlyWhen: [
            {
                filterGroup: FilterGroupEnum.rfrOrdDisconnected,
                hasValue: FilterEnum.rfrOrdDisconnectedYes,
            },
        ],
        changeValueWhen: [
            {
                filterGroup: FilterGroupEnum.rfrOrdDisconnected,
                hasValue: FilterEnum.rfrOrdDisconnectedYes,
                newValue: null,
            },
        ],
    },
    {
        groupTextKey: i18nInterface.textShowOnlyDisconnected,
        key: FilterGroupEnum.rfrOrdDisconnected,
        filterType: SpxInputTypeEnum.radio,
        filters: [
            {
                filterKey: FilterEnum.rfrOrdDisconnectedYes,
                filterTextKey: i18nInterface.textYes,
                filterTextVariables: {
                },
                defaultValue: true,
                targetValue: FilterEnum.rfrOrdDisconnectedYes,
            },
            {
                filterKey: FilterEnum.rfrOrdDisconnectedNo,
                filterTextKey: i18nInterface.textNo,
                filterTextVariables: {
                },
                defaultValue: false,
                targetValue: FilterEnum.rfrOrdDisconnectedNo,
            },
        ],
        isActive: true,
        defaultValue: FilterEnum.rfrOrdDisconnectedNo,
    },

];
